import { WeightunitPipe } from './weightunit.pipe';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedFacade } from './+state/shared.facade';
import { ConfiguratorFacade } from './+state/configurator.facade';
import { IssuesService } from './issues/issues.service';
import { BaseIssuesService } from '@icc/shared';
import { IssuesService as SharedIssuesService } from '@icc/shared/core';
import { CurrencyPipe } from '@icc/shared/helpers';
import { ModalService } from './modal.service';
import { ConfiguratorModalService } from './steps/modal.service';
import { DrawService } from './draw.service';
import { IccDrawModule } from '@icc/draw';
import { DrawResizeDirective } from './draw-resize/draw-resize.directive';
import { UnitmmPipe } from './unitmm.pipe';
import { UnitmPipe } from './unitm.pipe';
import { Unitm2Pipe } from './unitm2.pipe';
import { Unit2dPipe } from './unit2d.pipe';
import { FormatUnitPipe } from './format-unit.pipe';
import { HotkeyModule } from 'angular2-hotkeys';
import { PriceDetailsComponent } from './price-details/price-details.component';
import { CommonModule } from '@angular/common';
import { ProductFeaturesComponent } from './product-features/product-features.component';
import { DrawRefreshDirective } from './draw-resize/draw-refresh.directive';
import { DigitsOnlyDirective } from './directives/digits-only.directive';
import { NumberInputDirective } from './directives/number-input.directive';
import { FormsModule } from '@angular/forms';
import { SizeRangeService } from './size-range.service';
import { CONFIGURATIONS_SERVICE } from '@icc/configurator/types';
import { ConfigurationsService } from './configurations/configurations.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';


@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        IccDrawModule,
        HotkeyModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatExpansionModule,
    ],
    exports: [
        TranslateModule,
        IccDrawModule,
        DrawResizeDirective,
        DrawRefreshDirective,
        CurrencyPipe,
        UnitmmPipe,
        UnitmPipe,
        Unitm2Pipe,
        Unit2dPipe,
        FormatUnitPipe,
        WeightunitPipe,
        ProductFeaturesComponent,
        DigitsOnlyDirective,
        NumberInputDirective,
        FormsModule,
    ],
    declarations: [
        DrawResizeDirective,
        DrawRefreshDirective,
        CurrencyPipe,
        UnitmmPipe,
        UnitmPipe,
        Unitm2Pipe,
        Unit2dPipe,
        FormatUnitPipe,
        WeightunitPipe,
        PriceDetailsComponent,
        ProductFeaturesComponent,
        DigitsOnlyDirective,
        NumberInputDirective,
    ],
    providers: [
        DrawService,
        SharedFacade,
        ConfiguratorFacade,
        IssuesService,
        SizeRangeService,
        { provide: SharedIssuesService, useExisting: IssuesService },
        { provide: BaseIssuesService, useExisting: IssuesService },
        { provide: ModalService, useClass: ConfiguratorModalService },
        { provide: CONFIGURATIONS_SERVICE, useExisting: ConfigurationsService },
    ]
})
export class SharedModule {}
